import { ANALYTICS_CATEGORY_HOME } from '@/constants/analytics'
import analytics from '@/shared-utils/analytics'
import { GA4Event } from '@/shared-utils/ga4/types'

export default function fireRecentSearchesEvent(
  typeAheadEndpoint: string,
  recentOrRecommendationTitle: string,
  gaLabel: string
) {
  analytics.fireEvent({
    category: ANALYTICS_CATEGORY_HOME,
    action: `${typeAheadEndpoint} ${recentOrRecommendationTitle.toLowerCase()}`,
    label: gaLabel
  })
  analytics.fireGA4Event({
    event: GA4Event.SELECT_CONTENT,
    attributes: {
      type: 'search_form',
      item_name: 'recent_searches',
      product_name: typeAheadEndpoint === 'flights' ? 'flight' : 'hotel'
    }
  })
}
